import React from 'react';

import {DateTimePicker} from 'material-ui-pickers';
import Button from 'material-ui/Button';
import Divider from 'material-ui/Divider';

import {InputLabel} from 'material-ui/Input';
import {MenuItem} from 'material-ui/Menu';
import {FormHelperText, FormControl} from 'material-ui/Form';
import Select from 'material-ui/Select';

import axios from 'axios';
import moment from 'moment-timezone';
import tsl from './../../../tsl';
import { getSettings } from 'utils/client';

export default class Edit extends React.Component {
	
	state = {
		flight: {},
        aircrafts: [],
	};

    constructor(props) {
        super(props);
        // for some reason heving this set in componentWillReceiveProps is not enough
        this.state = { flight: props.flight, aircrafts: [] };
    }

    componentDidMount() {
        axios.get('/api/operator/aircrafts?perPage=1000')
            .then(res => {
                this.setState({ aircrafts: res.data.data });
            })
    }

	componentWillReceiveProps(newProps) {
        //console.log('edit receives props');
		this.setState({
			flight: newProps.flight
		});
	}

	save = () => {
		const flight = this.state.flight;

        if (flight.start_time) {
            const utcTime = moment(flight.start_time).utc().toISOString();
            flight.start_time = utcTime;
        }

		axios.post('/api/operator/flights/' + flight.id, flight)
			.then((res) => {
				this.props.onSave();
			});

	}

    close = () => {
        this.props.onClose();
    }

	handleDateTimeChange = (attr) => (date) => {
		let flight = this.state.flight;
		flight[attr] = date.format('YYYY-MM-DD HH:mm:ss');
		this.setState({ flight: flight });
	}

    handleRelationChange = (attr) => (e) => {
        const aircraft_id = e.target.value;
        let flight = this.state.flight;
        flight[attr] = aircraft_id ? { id: aircraft_id } : null;
        this.setState({ flight: flight });    
    }

	render() {
		const {flight} = this.state;
		const offer = flight.aircraft_offer.flight_offer;

        const start_time = moment(flight.start_time);
        const meeting_time = moment(flight.start_time).add(offer.time_before, 'minutes');
        const takeoff_time = start_time;
        const landing_time = moment(flight.start_time).add(offer.time_flight, 'minutes');
        const aircraft_free_time = moment(flight.start_time).add(offer.time_flight+offer.time_after, 'minutes');

		return (
            <div>

                <FormControl fullWidth>
                    <InputLabel htmlFor="language">{tsl('flight.edit.aircraft')}</InputLabel>
                    <Select
                        name="aircraft"
                        value={flight.aircraft ? flight.aircraft.id : 0}
                        onChange={this.handleRelationChange('aircraft')}
                    >
                        <MenuItem value={0}>{'- '+tsl('flight.edit.aircraft_none')+' -'}</MenuItem>
                        {this.state.aircrafts.map((aircraft) => {
                            return (<MenuItem key={aircraft.id} value={aircraft.id}>
                                    <i className="zmdi zmdi-circle" style={{color: aircraft.calendar.color_hex}} />
                                    {' ' + aircraft.reg_no}
                                </MenuItem>);
                        })}
                    </Select>
                </FormControl>
                <br />

                <div className={`jr-card-header-color text-center`}>
                    <div className="jr-card-hd-content text-white">
                        <br />
                        <DateTimePicker
			                fullWidth
			                label={tsl('flight.edit.start_time')}
			                value={flight.start_time}
			                onChange={this.handleDateTimeChange('start_time')}
			                format="LLL"
			                showTabs={false}
			                leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
			                rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                      ampm={getSettings('ampm', false)}
			            />
                    </div>
                </div>
                <div className="jr-card-body">

                    <div className="d-flex flex-column">

                        {
                            offer.time_pickup !== 0 &&
                              <div className="list-line-item">
                                <div className="list-line-badge"/>

                                <div className="list-line-content">
                                    <h3 className="mb-1">{tsl('flight.detail.timeline.takeoff_base')}</h3>
                                    <p className="text-muted">{tsl('flight.edit.meeting_relative', {minutes_before: offer.time_pickup})}</p>
                                </div>
                              </div>
                        }

                        <div className="list-line-item">
                            <div className={`list-line-badge bg-danger`}/>

                            <div className="list-line-content">
                                <h3 className={`text-danger mb-1`}>{tsl('flight.detail.timeline.meeting')}</h3>
                                <p className="text-muted">{tsl('flight.edit.meeting_relative', {minutes_before: offer.time_before})}</p>
                            </div>
                        </div>

                        <div className="list-line-item">
                            <div className="list-line-badge"/>

                            <div className="list-line-content">
                                <h3 className="mb-1">{tsl('flight.detail.timeline.takeoff')}</h3>
                                <p className="text-muted">{tsl('flight.edit.selected_time')}</p>
                            </div>
                        </div>

                        <div className="list-line-item">
                            <div className="list-line-badge bg-success"/>

                            <div className="list-line-content">
                                <h3 className="text-success mb-1">{offer.time_return !== 0 ? tsl('flight.detail.timeline.dropoff') : tsl('flight.detail.timeline.landing')}</h3>
                                <p className="text-muted">{tsl('flight.edit.landing_time_relative', {flight_type_minutes: offer.time_flight})}</p>
                            </div>
                        </div>

                        {
                            (offer.time_dropoff !== 0 || offer.time_return !== 0) &&
                              <div className="list-line-item">
                                <div className="list-line-badge"/>

                                <div className="list-line-content">
                                    <h3 className="mb-1">{tsl('flight.detail.timeline.takeoff')}</h3>
                                    <p className="text-muted">{tsl('flight.edit.landing_time_relative', {flight_type_minutes: offer.time_dropoff})}</p>
                                </div>
                              </div>
                        }

                        {
                            offer.time_return !== 0 &&
                              <div className="list-line-item">
                                <div className="list-line-badge bg-primary"/>

                                <div className="list-line-content">
                                    <h3 className="text-primary mb-1">{tsl('flight.detail.timeline.landing_base')}</h3>
                                    <p className="text-muted">{tsl('flight.edit.landing_time_relative', {flight_type_minutes: offer.time_return})}</p>
                                </div>
                              </div>
                        }

                        <div className="list-line-item">
                            <div className="list-line-badge"/>

                            <div className="list-line-content">
                                <h3 className="mb-1">{tsl('flight.detail.timeline.aircraft_free')}</h3>
                                <p className="text-muted">{tsl('flight.edit.aircraft_free_time_relative', {time_after_minutes: offer.time_after})}</p>
                            </div>
                        </div>

                    </div>
                </div>
                
                <div style={{textAlign: 'right'}}>
                    <Button onClick={this.close}>
                        {tsl('flight.edit.close')}
                    </Button>
                    <Button color="primary"	onClick={this.save}>
                    	{tsl('flight.edit.save')}
                    </Button>
                </div>

		</div>);
	}
}


// WEBPACK FOOTER //
// ./app/used/flights/routes/Edit.js